// daily_choices テーブルへの保存（有料会員かつログイン中のみ呼ぶ）
import { supabase } from '../../supabase';

export type DailyChoiceInsert = {
  entry_type: string;
  suggestion?: string | null;
  excited?: boolean | null;
  body_reaction?: string | null;
  free_text?: string | null;
  direction?: string | null;
  place_type?: string | null;
  mood_after?: string | null;
  coin_options?: string[] | null;
  coin_result?: string | null;
  coin_feeling?: string | null;
};

/** 1行追加して id を返す。失敗しても画面の流れは止めない。 */
export async function insertChoice(userId: string, row: DailyChoiceInsert): Promise<string | null> {
  const { data, error } = await supabase
    .from('daily_choices')
    .insert({ user_id: userId, ...row })
    .select('id')
    .single();
  if (error) { console.warn('[daily_choices] insert error', error); return null; }
  return data?.id ?? null;
}

export type DailyChoiceRow = DailyChoiceInsert & { id: string; created_at: string };

/** 自分の記録を新しい順に取得（RLSで本人の行だけが返る） */
export async function listChoices(limit = 300): Promise<DailyChoiceRow[]> {
  const { data, error } = await supabase
    .from('daily_choices')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) { console.warn('[daily_choices] select error', error); return []; }
  return (data as DailyChoiceRow[]) ?? [];
}

export async function updateChoice(id: string, patch: Partial<DailyChoiceInsert>): Promise<void> {
  const { error } = await supabase.from('daily_choices').update(patch).eq('id', id);
  if (error) console.warn('[daily_choices] update error', error);
}
